// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"141":"40ed7c9f","879":"c7dd7727"}[chunkId] + ".css";
};